class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)

// Menu burger mobile : cliquer sur le NOM d'un item ayant un sous-menu le déplie/replie
// (au lieu de devoir viser le « + »). Le lien parent ne navigue plus, il déclenche le
// même toggle que la flèche (collapsible-tab). Le « + » reste fonctionnel.
document.addEventListener('click', function (e) {
	var link = e.target.closest('a.f-mobile-nav__link, a.f-mobile-nav__sub-link')
	if (!link) return
	// Le <a> est enfant direct du <li> ; on n'agit que si ce <li> a un sous-menu.
	var li = link.parentElement
	if (!li || !li.hasAttribute('data-menu-toggle-item')) return
	var collapsible = li.querySelector(':scope > collapsible-tab')
	var trigger = collapsible && collapsible.querySelector('[data-trigger]')
	if (!trigger) return
	e.preventDefault()
	trigger.click()
})
